import { registerPlugin } from '@capacitor/core';

// Plugin iOS. En Android la caja embebida usa `capacitor-nodejs`; en web no existe.
// Métodos:
//   start({ env })  → { started: boolean, alreadyRunning: boolean, dataDir, nodeDir }
//   getInfo()       → { running: boolean, dataDir, nodeDir }
export const HubRuntime = registerPlugin('HubRuntime');
